export const SEARCH_COMPONENT_COLOR = '#f44225';

export const SNS_BANNER_EXPIRING_DURATION = 24;
export const SNS_BANNER_INCREMENT_Z_INDEX = 300;
export const LINE_BANNER_ID = 'line_banner';
export const INSTAGRAM_BANNER_ID = 'instagram_banner';
export const CLOSE_SNS_BANNER_ID = 'close_sns_banner';

export const SCHEDULE_SNACKBAR_EXPIRING_DURATION = 24;
export const SCHEDULE_SNACKBAR_INCREMENT_Z_INDEX = 400;
